// The commands the setup page hands a member, built from where the page is
// being served.
//
// The sign-in command carries this portal's own address. The CLI cannot work
// it out: when it asks for a sign-in code nobody is signed in yet, so the
// server does not know which org's portal to name. Without `--portal` the CLI
// can only say "open your Ploy portal", and a hand-typed or copied address is
// how members have ended up pointed at somebody else's subdomain. By the time
// this page renders, the canonical-portal redirect has already run, so the
// origin is this org's real one.

export const INSTALL_COMMAND =
  "curl -fsSL https://cli.joinploy.com/install | sh";

export function signInCommand(origin: string): string {
  return `ploy auth login --portal ${origin.replace(/\/+$/, "")}`;
}

export const REQUEST_COMMAND = "ploy request";
